module.exports = __webpack_public_path__ + "static/media/jeffreyLSnyder.7f64d6e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/jeffreyLSnyder.jpg
// module id = 1570
// module chunks = 1